import ApolloClient from "apollo-client";

import { InMemoryCache } from "apollo-cache-inmemory";
import gql from "graphql-tag";
import { graphql, QueryResult } from "react-apollo";

import { generateApolloLink } from "~/graphql/client";

interface IShipmentEvent {
  id: string;
  occurredAt: string;
  status: string;
}

export interface IShipment {
  id: string;
  trackingNumber: string;
  lastEventStatus: string;
  shipmentEvents: IShipmentEvent[];
  orderLineItems: IOrderLineItemConnection;
}

export interface IShipmentConnection {
  edges: IShipmentNode[];
}

interface IShopifyProductImages {
  src: string;
}

export interface IShopifyProduct {
  title: string;
  totalPrice: string;
  productImages: IShopifyProductImages[];
}

export interface IShopProduct {
  id: string;
  shopifyProduct: IShopifyProduct;
}

export interface IOrderLineItem {
  id: string;
  price: string;
  quantity: number;
  barcode: string | undefined | null;
  shopProduct: IShopProduct;
  productTitle: string;
  productVariantTitle: string;
  imageSrc: string;
}

export interface IOrderLineItemConnection {
  edges: IOrderLineItemNode[];
}

interface IShipmentNode {
  node: IShipment;
}

interface IOrderLineItemNode {
  node: IOrderLineItem;
}

export interface IOrder {
  id: string;
  name: string;
  insertedAt: string;
  shipments: IShipmentConnection;
  orderLineItems: IOrderLineItemConnection;
}

export interface IOrderByName {
  orderByName: IOrder;
}

export interface IResponseProps {
  orderByNameQuery: IOrderByName & QueryResult;
}

export interface IInputProps {
  orderNumber: string;
  postalCode: string;
}

export const ORDER_SHIPMENTS_QUERY = gql`
  query OrderByName($name: String!, $zip: String!) {
    orderByName(name: $name, zip: $zip) {
      id
      name
      shipments(first: 10) {
        edges {
          node {
            id
            trackingNumber
            shippingDays
            lastEventStatus
            shipmentEvents {
              id
              occurredAt
              status
            }
            orderLineItems(first: 10) {
              edges {
                node {
                  id
                  quantity
                  price
                  totalPrice
                  productTitle
                  productVariantTitle
                  imageSrc
                  shopProduct {
                    shopifyProduct {
                      title
                      productImages {
                        src
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const ORDER_LINE_ITEMS_QUERY = gql`
  query OrderByName($name: String!, $zip: String!) {
    orderByName(name: $name, zip: $zip) {
      id
      name
      insertedAt
      orderLineItems(first: 10) {
        edges {
          node {
            id
            quantity
            barcode
            price
            totalPrice
            shopProduct {
              id
              shopifyProduct {
                title
                productImages {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`;

const NEXUS_API_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.nexusapp.co/nexus/public/graphql"
    : "https://api.nexusapp.test/nexus/public/graphql";

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: generateApolloLink(NEXUS_API_URL)
});

export default client;

export const withOrderByName = graphql<IInputProps>(ORDER_SHIPMENTS_QUERY, {
  name: "orderByNameQuery",
  options({ orderNumber, postalCode }) {
    return {
      client,
      variables: {
        name: orderNumber,
        zip: postalCode
      }
    };
  }
});



// WEBPACK FOOTER //
// ./src/graphql/queries/order/orderByName.ts